export * from './entity-detail-attribute.component';
